import React from 'react';
import InfoCard from '../../InfoCard/InfoCard';
import InventoryData from '../../../Datas/InventoryData';
import './Dashboard.css';
import Table from '../../RecentOrdersTable/RecentOrdersTable';
import IndentCards from '../../IndentCards/IndentCards';

const Dashboard = ({ role }) => {
  const formatDateToComparable = (date) => {
    const [day, month, year] = date.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  const expiredMeds = InventoryData.filter(med => formatDateToComparable(med.expiryDate) < new Date());

  const lowStockMeds = InventoryData.filter(med => med.tablets <= 100); 

  const expiringMeds = InventoryData.filter(med => {
    const expiryDate = formatDateToComparable(med.expiryDate);
    const daysToExpiry = Math.ceil((expiryDate - new Date()) / (1000 * 3600 * 24));
    return daysToExpiry >= 0 && daysToExpiry <= 30; 
  });

  let cardcontent;
  if (role === 'distributor') {
    cardcontent = null; 
  } else {
    cardcontent = <IndentCards />;
  }

  return (
    <div className='maincontent'>
      <div className='InfoCard'>
        <InfoCard
          title="Expired Meds"
          color="rgba(128, 128, 128)"  
          data={expiredMeds}
        />
        <InfoCard
          title="Low Stock Meds"
          color="rgba(210, 210, 0)" 
          data={lowStockMeds}
        />
        <InfoCard
          title="Expiring Meds"
          color="rgba(250, 2, 2)"  
          data={expiringMeds}
        />
      </div>

      <div>
        {cardcontent}
      </div>

      <div className='RecentOrders'>
        <Table />
      </div>
    </div>
  );
};

export default Dashboard;
